import USERAPI from './user.api'

export default USERAPI
